import { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { getImageSize, POPUP_VIDEO_RENEW } from '../../../utils';

const VideoType = ({ item, mediaClass, size, height, width, url, poster, autoPlay, muted, isCover, controls, loop, isupdate }) => {

  const [videoLoaded, setVideoLoaded] = useState(false)
  const [padding, setPadding] = useState(size ? size : 100)
  const playerRef = useRef(null)

  // Force the underlying player to actually stop making sound whenever this
  // video is no longer the active one (slider moved) or the component unmounts
  // (navigating to another post). react-player's controlled props alone don't
  // reliably silence native/embedded players, so we pause + mute directly.
  const stopPlayback = () => {
    try {
      const internal = playerRef.current?.getInternalPlayer?.()
      if (internal) {
        if (typeof internal.pause === 'function') internal.pause()
        if (typeof internal.muted !== 'undefined') internal.muted = true
      }
    } catch (e) { /* noop */ }
  }

  useEffect(() => {
    if (!autoPlay) stopPlayback()
  }, [autoPlay])

  useEffect(() => {
    return () => stopPlayback()
  }, [])

  const onMediaLoad = async () => {
    if (size) {
      setPadding(size)
    } else {
      if (height && height != "" && width && width != "") {
        setPadding((height * 100) / width)
      } else {
        try {
          const { width, height } = await getImageSize(poster);
          setPadding((height * 100) / width)
        } catch (error) {
          setPadding(100)
        }
      }
    }
  }


  useEffect(() => {
    onMediaLoad()
  }, [size])

  // const onErrorImageUpdate = event => {
  //   event.target.src = ErrImg
  // }
  const videoLoadedFun = () => {
    setVideoLoaded(true)
  }
  return <div className={`${mediaClass} overflow-hidden position-relative`} style={{ paddingBottom: `${padding}%` }}>
    <div className="position-absolute object-center-cover h-100 w-100">
      <ReactPlayer
        ref={playerRef}
        poster={poster}
        className={''}
        url={url}
        config={{
          facebook: { appId: '117029975354072' },
          file: {
            attributes: { 'data-item-id': item?.id, 'poster': poster, 'data-network': item?.networkId, 'data-item-id': item?.id, 'data-stories': item?.stories, "data-load": '0', }
          }
        }}
        autoPlay={autoPlay}
        muted={muted}
        volume={autoPlay ? 1 : 0}
        playsinline={true}
        onReady={(e) => { videoLoadedFun(true) }}
        playing={autoPlay}
        height={'100%'}
        width={'100%'}
        loop={loop}
        controls={controls}
        onError={isupdate ? (e) => { POPUP_VIDEO_RENEW(e) } : () => { }}
        style={{ backgroundImage: (!videoLoaded) ? `url(${poster})` : '', backgroundSize: isCover ? 'cover' : 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
      />
    </div>
  </div>
}
export default VideoType